export { Provider as ReduxProvider } from 'react-redux';
